import React from 'react';
import { usePersistentGlobalState } from '#modules/utils/usePersistentState';

export const BankingContext = React.createContext({});

export const BankingProvider = ({ children }) => {
  const [loading, setLoading] = React.useState(false);
  const [bankAccounts, setBankAccounts] = React.useState(null);

  const [displayCurrencyCode, setDisplayCurrencyCode] =
    usePersistentGlobalState('displayCurrencyCode', 'AUD');
  const value = {
    bankAccounts,
    setBankAccounts,
    loading,
    setLoading,
    displayCurrencyCode,
    setDisplayCurrencyCode,
  };
  return (
    <BankingContext.Provider value={value}>{children}</BankingContext.Provider>
  );
};
